import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopEPNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Étude IFOP - Charles"
        links={[
          {
            to: '/ifop-ejaculation-precoce/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="3rem" width="3rem" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/rapport-complet-ifop-ejaculation-precoce/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="3rem" width="3rem" />
                <span>Voir l&apos;enquête complète</span>
              </HStack>
            )
          },
          {
            to: '/ifop-ejaculation-precoce-analyse-francois-kraus/',
            content: (
              <HStack>
                <ImageBox alt="chat" src="/icons/open-iconic/svg/chat.svg" height="3rem" width="3rem" />
                <span>Analyse de François Kraus</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopEPNavigation
